import React from 'react'
import '../Theme.css';
import './Checkbox.css';
import Text from "../text/Text";
import {HiCheck} from "react-icons/hi";

function Checkbox({style, text, checked, onClick}) {
    const className = "CheckBoxButton " + style;

    return (
        <button className={className} onClick={onClick}>
            <div className="CheckBox">
                <div className={"CheckBoxBox"}>
                    {(() => {
                        if (checked) {
                            return <HiCheck size={20} color={"#d1d4d7"}/>
                        }
                    })()}
                </div>
                <Text style={"CheckBoxText"} text={text}/>
            </div>
        </button>

    )
}

export default Checkbox;
